import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { getNounOverride } from "@whoosh/utilities/src/FormatNounOverride/getNounOverride";

import { useFacilityLessonNoun_facility$key } from "./__generated__/useFacilityLessonNoun_facility.graphql";

export const useFacilityLessonNoun = (
  facilityRef: useFacilityLessonNoun_facility$key | null,
  lowercaseFirstLetter?: boolean
) => {
  const facility = useFragment(
    useFacilityLessonNounFragmentString,
    facilityRef
  );
  const copyOverrides = facility?.copyOverrides?.lesson;

  return {
    singular: getNounOverride(
      copyOverrides?.singular,
      t`lesson`,
      !!lowercaseFirstLetter
    ),
    plural: getNounOverride(
      copyOverrides?.plural,
      t`lessons`,
      !!lowercaseFirstLetter
    ),
  };
};

const useFacilityLessonNounFragmentString = graphql`
  fragment useFacilityLessonNoun_facility on Facility {
    copyOverrides {
      lesson {
        plural
        singular
      }
    }
  }
`;
